// extracted by mini-css-extract-plugin
export default {"wrapper":"Company_wrapper__6jgfh"};